module.exports = __webpack_public_path__ + "static/media/7.1084e4bc.png";